module.exports = __webpack_public_path__ + "img/batteryDetectBg2Ru.d4a222bd.png";